import * as EmailValidator from 'email-validator';
import { Auth } from 'aws-amplify';
import { showError } from '../common/alerts/alerts';
import Logger from '../../utility/services/Logger';

export const isValidEmail = (signUpEmail) =>
  EmailValidator.validate(signUpEmail);

export const isNotEmpty = (field) => field.length > 0;

export const isNotValidName = (name) => name.match(/^[a-zA-Z ]*$/);

const isValidPassword = (isPasswordValid, signUpPassword) => {
  const hasLowercase = (str) => /[a-z]/.test(str);
  const hasUppercase = (str) => /[A-Z]/.test(str);
  const hasNumber = (str) => /[0-9]/.test(str);
  const hasSpecialChar = (str) => /[^A-Za-z0-9]/.test(str);
  return (
    isPasswordValid &&
    hasUppercase(signUpPassword) &&
    hasLowercase(signUpPassword) &&
    hasNumber(signUpPassword) &&
    hasSpecialChar(signUpPassword) &&
    signUpPassword.length >= 8
  );
};

export const isValidSignUp = (
  firstName,
  lastName,
  isPasswordValid,
  signUpPassword,
  signUpEmail,
  repeatPassword,
) => {
  if (!isValidEmail(signUpEmail)) {
    return false;
  }
  if (!isNotEmpty(firstName) || !isNotValidName(firstName)) {
    return false;
  }
  if (!isNotEmpty(lastName) || !isNotValidName(lastName)) {
    return false;
  }
  if (!isValidPassword(isPasswordValid, signUpPassword)) {
    return false;
  }
  if (
    signUpPassword !== repeatPassword ||
    signUpPassword === '' ||
    repeatPassword === ''
  ) {
    return false;
  }

  return true;
};

export const fetchQueryParams = (props) => {
  const { location } = props;
  if (!location) {
    return null;
  }
  const { search } = location;
  const query = new URLSearchParams(search);

  const queryArray = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const param of query.entries()) {
    queryArray.push(...param);
  }

  return queryArray;
};

export const handleSignUp = async (
  firstName,
  lastName,
  preferredUsername,
  isPasswordValid,
  signUpPassword,
  signUpEmail,
  referrer,
  repeatPassword,
  couponsAndDeals,
) => {
  const isSignUpValid = !isValidSignUp(
    firstName,
    lastName,
    isPasswordValid,
    signUpPassword,
    signUpEmail,
    repeatPassword,
  );
  if (isSignUpValid) {
    showError(
      'Not all of the fields are filled out properly. Please double check and try again.',
    );
    return false;
  }
  const referrerId = referrer;
  const attributes = {
    email: signUpEmail,
    name: firstName,
    family_name: lastName,
    preferred_username:
      preferredUsername.length > 0 ? preferredUsername : firstName,
    'custom:referrerId': referrerId,
  };
  if (!referrerId) {
    delete attributes['custom:referrerId'];
  }
  try {
    const data = await Auth.signUp({
      email: signUpEmail,
      password: signUpPassword,
      username: signUpEmail,
      attributes,
      clientMetadata: {
        emailSubscription: `${couponsAndDeals}`,
        source: window.location.host,
      },
    });

    return data;
  } catch (err) {
    switch (err.code) {
      case 'UsernameExistsException':
        showError('A user already exists with that email');

        break;
      default:
        Logger.LogError(err);

        showError("Uh oh! Something went wrong and I couldn't sign you up");
    }
    return null;
  }
};
